<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div v-if="proposal.module" class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 text-left">
                  <h4>Proposal ID</h4>
                  <p>{{ proposal.proposal_id }}</p>
                </div>
                <div class="col-md-6 text-right">
                  <h4>Description</h4>
                  <p>{{ proposal.module }}<span v-if="proposal.description">:&nbsp;{{ proposal.description }}</span></p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 text-left m-b-15">
                  <h4>Proposal Status</h4>
                  <status :status="proposal.status" />
                </div>
                <div class="col-md-6 text-right">
                  <h4>Your voting status</h4>
                  <status :status="proposal.voting_status" />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 text-left">
                  <h4>Comments</h4>
                  <p v-if="proposal.comments">
                    {{ proposal.comments }}
                  </p>
                  <p v-else>
                    NA
                  </p>
                </div>
                <div class="col-md-6 text-right">
                  <h4>Transaction</h4>
                  <p>
                    <a target="_blank" :href="$BORLAUG + '/proposals/' + proposal.proposal_id">View
                      Confirmation on Blockchain</a>
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 text-left">
                  <h4>Total votes required</h4>
                  <p><b>{{ proposal.votes.threshold }}</b></p>
                </div>

                <div class="col-md-6 text-right">
                  <h4>No. of votes pending</h4>
                  <p><b>{{ (proposal.votes.threshold - proposal.votes.ayes.length) }}</b></p>
                </div>
              </div>
              <div class="row">
                <table class="table table-bordered">
                  <tr>
                    <th class="p-2 font-bold">
                      Voters
                    </th>
                    <th class="p-2 font-bold">
                      Status
                    </th>
                  </tr>
                  <tr v-for="(voter, index) in proposal.voters" :key="index">
                    <td class="p-2">
                      <address-book-by-public-key :public-key="voter.address" />
                    </td>
                    <td>
                      <status :status="voter.approve?'Approved':'Rejected'" />
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div v-if="proposal.status === 'InProgress'" class="card-footer">
              <div class="form-group m-b-0 text-right">
                <div class="button-group">
                  <button v-if="proposal.voting_status!=='Approved'" type="button" class="btn waves-effect waves-light btn-success" @click="vote_yes(proposal.proposal_id)">
                    Approve
                  </button>
                  <button v-if="proposal.voting_status!=='Rejected'" type="button" class="btn waves-effect waves-light btn-danger" @click="vote_no(proposal.proposal_id)">
                    Reject
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EventBus from '../../../../event-bus';
import AddressBookByPublicKey from '../../common/AddressBookByPublicKey.vue';
import Status from '../../common/Status.vue';
import { proposalStatus } from '@/utils/utils';
import {apiMixin} from '@/utils/api-mixin';

export default {
  name: 'ViewProposal',
  components: { AddressBookByPublicKey, Status },
  mixins: [apiMixin('audit')],
  props: ['proposalId'],
  data() {
    return {
      proposal: {
        module: null,
        description: null
      },
      $TIMEOUT: this.$TIMEOUT
    };
  },
  computed: {
    ...mapGetters(['activeGroup', 'publicKey'])
  },
  watch: {
    proposalId() {
      this.getProposal();
    }
  },
  mounted() {
    this.getProposal();
  },
  methods: {
    async getProposal() {
      try {
        EventBus.$emit('showBlockUI');
        this.proposal = (await this.$api.get(`/groups/proposals/${this.proposalId}`)).data;
        proposalStatus(this.proposal, this.publicKey);

        const yes_voters = this.proposal.votes.ayes.map(y => ({
          address: y[0],
          approve: true
        }));
        const no_voters = this.proposal.votes.nays.map(n => ({
          address: n[0],
          approve: false
        }));
        this.proposal.voters = [...yes_voters, ...no_voters];
      } catch (e) {
        console.error(e);
      } finally {
        EventBus.$emit('hideBlockUI');
      }
    },
    async vote_yes() {
      // eslint-disable-next-line no-unused-vars
      let isProposal = false;
      if (this.activeGroup && this.activeGroup.threshold > 1) {
        isProposal = true;
      }
      await this.callApi('loader', isProposal, 'Proposal approved', async () => {
        await this.$api.post(`/groups/groups/${this.activeGroup.group_id}/proposals/${this.proposalId}/vote`, {
          approve: true
        }, {
          headers: {
            'API-group-id': this.activeGroup.group_id
          }
        });
      })
      await this.getProposal();
      this.$root.$emit('updateNotifications');
    },
    async vote_no() {
      // eslint-disable-next-line no-unused-vars
      let isProposal = false;
      if (this.activeGroup && this.activeGroup.threshold > 1) {
        isProposal = true;
      }
      await this.callApi('loader', isProposal, 'Proposal rejected', async () => {
        await this.$api.post(`/groups/groups/${this.activeGroup.group_id}/proposals/${this.proposalId}/vote`, {
          approve: false
        }, {
          headers: {
            'API-group-id': this.activeGroup.group_id
          }
        });
      })
      await this.getProposal();
      this.$root.$emit('updateNotifications');
    }
  }
}
</script>

<style scoped>
</style>
